export enum AppFlavour {
  OSANavigator = 'OSANavigator',
  MedicineProfile = 'MedicineProfile',
}
